import React, {useEffect, useState} from "react";
import styled from "styled-components";

import Popup from "../Popup";
import Button from "../Button";
import DefaultCalendar from "../Calendar";
import CalendarMonth from "components/ui/calendar/Month";

export const Calendar = (props) => {
	const [value, setValue] = useState(props.value || "");
	const [visible, setVisible] = useState(props.open || false);

	useEffect(() => {
		setValue(props.value);
	}, [props, visible]);


	const eventHandler = {
		open : () => {
			setVisible(true);
		},
		close : (value) => {
			setVisible(false);
		},
		change : (value) => {
			setValue(value);
		},
		submit : () => {
			setVisible(false);
			if(value && props.onChange) {
				props.onChange(props.name, value);
			}
		}
	};

	return (
		<Wrapper>
			<span onClick={eventHandler.open}>{props.children}</span>
			<Popup open={visible} onClose={eventHandler.close}>
				<div className="middle">
					<CalendarMonth mode={props.mode} value={value} date={props.date} import={true}
						onChange={eventHandler.change}
					/>
				</div>
				<div className="bottom">
					<Button color="blue" onClick={eventHandler.submit}>확인</Button>
				</div>
			</Popup>
		</Wrapper>
	);
};

const Wrapper = styled.div``;

export default Calendar;